module.exports = __webpack_public_path__ + "img/1541366646.e8b76cdf.jpg";